/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketSelectItem } from '../../models/support-ticket-select-item';

export interface SetParentTicket$Params {
      body?: {
'id'?: number;
'parentID'?: number;
}
}

export function SetParentTicket(http: HttpClient, rootUrl: string, params?: SetParentTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketSelectItem>> {
  const rb = new RequestBuilder(rootUrl, SetParentTicket.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketSelectItem>;
    })
  );
}

SetParentTicket.PATH = '/api/Tickets/SetParentTicket';
